import { Routes } from 'utils/constants';

import { IconChartInfographic } from '@tabler/icons';

import type { NavItemType } from 'models';
import type { MenuItemsCA } from './index';
import { conditionalRoute } from 'routes/routeUtils';

const reporting = (menuItemsCA: MenuItemsCA): NavItemType => ({
  id: 'reporting',
  title: '',
  type: 'group',
  children: [
    {
      id: 'reporting-group',
      title: 'navigation.reporting.group',
      type: 'collapse',
      icon: IconChartInfographic,
      children: [
        ...conditionalRoute(
          {
            id: 'report-market-imbalance',
            title: 'navigation.reporting.marketImbalance',
            type: 'item',
            url: Routes.REPORTING.MARKET_IMBALANCE
          },
          menuItemsCA.canAccessSystemImbalanceReportsPage
        ),
        ...conditionalRoute(
          {
            id: 'report-balancing-group',
            title: 'navigation.reporting.balancingGroup',
            type: 'item',
            url: Routes.REPORTING.BALANCING_GROUP
          },
          menuItemsCA.canAccessBalancingGroupReportsPage
        ),
        ...conditionalRoute(
          {
            id: 'report-device-production-plan',
            title: 'navigation.reporting.deviceProductionPlan',
            type: 'item',
            url: Routes.REPORTING.DEVICE_PRODUCTION_PLAN
          },
          menuItemsCA.canAccessDeviceProductionPlanReportsPage
        ),
        ...conditionalRoute(
          {
            id: 'report-delivery-point-production-plan',
            title: 'navigation.reporting.deliveryPointProductionPlan',
            type: 'item',
            url: Routes.REPORTING.DELIVERY_POINT_PRODUCTION_PLAN
          },
          menuItemsCA.canAccessDeliveryPointProductionPlanReportsPage
        ),
        {
          // TODO: CA
          id: 'report-economic-benefits',
          title: 'navigation.reporting.economicBenefits',
          type: 'item',
          url: Routes.REPORTING.ECONOMIC_BENEFITS
        }
      ]
    }
  ]
});

export default reporting;
